import React, { useEffect, useState } from "react";
import Router from "./Router";
import SvgSprite from "./utils/SvgSpriteLoader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import "./ant.less";

import Header from "./containers/Header";
import Footer from "./containers/Footer";
import svgFile from "./assets/images/svg/svg-sprite.svg";
import Cards from "./containers/Cards";
import { useDispatch } from "react-redux";


const App = () => {
  const dispatch = useDispatch();
  const [userAddress, setUserAddress] = useState();


  useEffect(() => {
    let alreadyConnected = localStorage.getItem("ac");
    dispatch({ type: "USER_ADDRESS", value: alreadyConnected });
    setUserAddress(alreadyConnected)

  }, [userAddress])

  return (
    <>
      <SvgSprite url={svgFile} />
      <div className="main_wrapper">
        <div className="main-container">
          <ToastContainer />
          <Header />
          <Router />
          <Footer />
        </div>
      </div>
    </>
  );
};

export default App;